import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconReadme({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M17 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10zm0 1h-.268c.17.294.268.636.268 1v12c0 .365-.098.707-.268 1.001L17 19a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-2 0H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8V5zm0 0v14a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-1.5 11a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0-3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"/>
        </svg>
    );
}

export default IconReadme;
